import React from 'react';

interface Props {
  title: string;
  description: string | React.ReactNode;
  onDismiss?: () => void;
}

export const TutorialDescription: React.FC<Props> = ({ title, description, onDismiss }) => {
  return (
    <div className="flex flex-col space-y-2 flex-1 items-start">
      <h4 className="font-bold">{title}</h4>
      <h4 className="leading-5 text-gray-500 grow">{description}</h4>
      <h4 className="text-blue-900 cursor-pointer" onClick={() => onDismiss && onDismiss()}>
        Dismiss
      </h4>
    </div>
  );
};
